// extracted by mini-css-extract-plugin
module.exports = {"psti":"PSTIStatement_psti__nc0Wb"};